import dayjs from 'dayjs';
import localizedFormat from 'dayjs/plugin/localizedFormat';
dayjs.extend(localizedFormat);

(function () {
    'use strict';

    angular
        .module('ib-MmB-filters-module')
        .filter('DateFormatFilter', DateFormatFilter);

    DateFormatFilter.$inject = ['MmBUtilService'];
    function DateFormatFilter(MmBUtilService) {
        var months = [
            'MONTH_JANUARY',
            'MONTH_FEBRUARY',
            'MONTH_MARCH',
            'MONTH_APRIL',
            'MONTH_MAY',
            'MONTH_JUNE',
            'MONTH_JULY',
            'MONTH_AUGUST',
            'MONTH_SEPTEMBER',
            'MONTH_OCTOBER',
            'MONTH_NOVEMBER',
            'MONTH_DECEMBER'
        ];
        var weekDays = [
            'WEEKDAY_MONDAY',
            'WEEKDAY_TUESDAY',
            'WEEKDAY_WEDNESDAY',
            'WEEKDAY_THURSDAY',
            'WEEKDAY_FRYDAY',
            'WEEKDAY_SATURDAY',
            'WEEKDAY_SUNDAY'
        ];

        return formatDate;

        ////////////////

        function formatDate(inputDate, format) {
            var dateTime, date, numWeekDay, month, deleteHyphen, transformedDate, utilsDate;
            if (inputDate) {
                dateTime = inputDate.indexOf(' ') !== -1 ? inputDate.split(' ')[1] : '';
                date = dayjs(inputDate);
                numWeekDay = date.isoWeekday();
                month = date.month();
                deleteHyphen = new RegExp('-', 'g');
                transformedDate = inputDate.replace(deleteHyphen, '/');
                utilsDate = {
                    'dateTime': dateTime,
                    'weekDay': weekDays[numWeekDay - 1],
                    'day': date.date(),
                    'monthNumber': month + 1,
                    'month': months[month],
                    'year': date.year(),
                    'originalDate': dayjs(transformedDate).format()
                };
                utilsDate['formatedDate'] = MmBUtilService.getFormatedDate(date, format) ? MmBUtilService.getFormatedDate(date, format).formatedDate : null;
            }
            return utilsDate;
        }
    }
})();
